
import { FormComponent } from "../../../utils/enums";

export const reorderMedicationSchema = {
    "name": "reorderMedicationForm",
    "type": "form",
    "target": "submit",
    "title": "Re-order Medication",
    "properties": {
        "medicationName": {
            "label": "Medication",
            "type": "text",
            "required": true,
            "component": FormComponent.Display,
        },
        "currentStock": {
            "label": "Current Stock",
            "type": "number",
            "required": true,
            "component": FormComponent.Display,
        },
        "supplier": {
            "label": "Supplier",
            "type": "text",
            "required": true,
            "component": FormComponent.Display,
        },
        "orderQuantity": {
            "label": "Order Quantity",
            "type": "number",
            "required": true,
            "component": FormComponent.Input,
            "componentProps": {
                "placeholder": "e.g., 500",
                "type": "number",
                "min": 1
            }
        }
    }
} 